import { PRODUCTS_BY_SLUG } from '../constants/ecommerceData';
import type { SubscriptionType } from '../../@types/Subscription';

// Slugs of the older subscription products that predate the
// Plataformas / Profesionista / Empresarial plans.
//
// A user is on a "legacy" plan when one of their active subscriptions matches
// one of these slugs. We mostly use it to gate cross-sells and to show a
// "you're on an old plan" upgrade hint instead of treating the user as
// brand-new.

export const LEGACY_PLAN_SLUGS: readonly string[] = [
	PRODUCTS_BY_SLUG.HERU_PLUS,
	PRODUCTS_BY_SLUG.ACTIVIDAD_EMPRESARIAL,
	PRODUCTS_BY_SLUG.RESICO,
	PRODUCTS_BY_SLUG.PLATAFORMAS_TECNOLOGICAS,
	PRODUCTS_BY_SLUG.ARR_MONTHLY,
];

export const isLegacyPlanSlug = (
	slug: string | undefined | null,
): boolean => {
	if (!slug) return false;
	return LEGACY_PLAN_SLUGS.includes(slug);
};

export const hasLegacySubscription = (
	activeSubscriptions: SubscriptionType[] | undefined | null,
): boolean => {
	if (!activeSubscriptions?.length) return false;
	return activeSubscriptions.some((sub) =>
		isLegacyPlanSlug(sub?.product_version?.product?.slug),
	);
};
